import { AppClient } from "../submodules/rapdv/client/app/AppClient"
import { ClientPage } from "../submodules/rapdv/client/elements/PagesCtrl"
import { PageVerifyEmails } from "./pages/PageVerifyEmails"
import { DropzoneOrdered } from "./elements/dropzone-ordered/DropzoneOrdered"
import SlimSelect from "slim-select/dist/slimselect.min.js"
import CookiesEuBanner from "cookies-eu-banner/dist/cookies-eu-banner.min.js"
import { PageEditArticle } from "./pages/PageEditArticle"
import { Tooltip } from "../submodules/rapdv/client/elements/Bootstrap"
import { Lightbox } from "./elements/Lightbox"
import { PageEditLocation } from "./pages/PageEditLocation"
import { PageLogin } from "./pages/PageLogin"
import { PageFeedback } from "./pages/PageFeedback"
import { PageRestaurantDetails } from "./pages/PageRestaurantDetails"
import { PanelSelectPlan } from "./pages/PanelSelectPlan"
import { PanelOpeningHours } from "./pages/PanelOpeningHours"
import { PanelMenuEditor } from "./pages/PanelMenuEditor"
import { PanelTeamInvite } from "./pages/PanelTeamInvite"
import { PanelDeliveryOptions } from "./pages/PanelDeliveryOptions"
import { PanelPublish } from "./pages/PanelPublish"
import { PanelActivated } from "./pages/PanelActivated"
import { PageOrders } from "./pages/PageOrders"
import { PagePrintOrder } from "./pages/PagePrintOrder"
import { PagePrintMenu } from "./pages/PagePrintMenu"
import { PagePrintQrMenu } from "./pages/PagePrintQrMenu"
import { PageRestaurant } from "./pages/PageRestaurant"
import { PageStorePrinter } from "./pages/PageStorePrinter"
import { PageRestaurantOrder } from "./pages/PageRestaurantOrder"
import { PageRestaurantOrderConfirmation } from "./pages/PageRestaurantOrderConfirmation"
import { PageThemeEdit } from "./pages/PageThemeEdit"
import { PageManageLeads } from "./pages/PageManageLeads"
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import "./styles/cookies-banner.scss"
import "slim-select/dist/slimselect.css"
import "medium-editor/dist/css/medium-editor.min.css"
import "medium-editor/dist/css/medium-editor.min.css"
import "medium-editor/dist/css/themes/beagle.min.css"
import 'swiper/swiper-bundle.css';
import "maplibre-gl/dist/maplibre-gl.css"
import "./styles/style.scss"
import "twemoji-awesome-lib"
import "./styles/app-nav.scss"
import "./styles/page-onboarding.scss"
import "./styles/pwa-install.scss"
import "./styles/menu-editor.scss"
import "./styles/orders-page.scss"
import "./styles/restaurant-page.scss"
import "./styles/print-order.scss"
import "./styles/print-menu.scss"
import "./styles/print-confirmation.scss"
import "./styles/print-qr.scss"
import "./styles/location-picker.scss"
import "./styles/delivery-areas.scss"
import "./styles/landing-page.scss"
import "./elements/star-selector/style.scss"
import { PwaInstall } from "./elements/PwaInstall"
import { SocketClient } from "./socket/SocketClient"
import { OrderToast } from "./elements/OrderToast"
import { ModalBackdrop } from "./elements/ModalBackdrop"
import { HOSTED_APP_BODY_CLASS } from "../server/hosted/HostedConstants"

const setupSearchableSelects = () => {
  const allSelectElements = document.querySelectorAll("select.searchable")
  for (const selectElement of allSelectElements) {
    new SlimSelect({
      select: selectElement
    })
  }
}

const setupTooltips = () => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  for (const tooltipTriggerEl of tooltipTriggerList) {
    new Tooltip(tooltipTriggerEl)
  }
}

const setupCarousel = () => {
  const carousels: any = document.querySelectorAll(".swiper")
  for (const carousel of carousels) {
    new Swiper(carousel, {
      modules: [Navigation, Pagination],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: carousel.querySelector('.swiper-button-next'),
        prevEl: carousel.querySelector('.swiper-button-prev')
      },
      pagination: {
        el: carousel.querySelector('.swiper-pagination'),
        clickable: true,
      },
      touchRatio: 1,
      observer: true, 
      observeParents: true
    });
  }
}

const setupLightbox = () => {
  const lightboxes = document.querySelectorAll('img[data-toggle="lightbox-image"]')

  for (const lightbox of lightboxes) {
    lightbox.addEventListener("click", Lightbox.initialize)
  }
}

const onPageLoaded = () => {
  DropzoneOrdered.setupDropzones()
  setupSearchableSelects()
  setupTooltips()
  setupCarousel()
  setupLightbox()
}

SocketClient.initialize()
new PwaInstall().setup()
ModalBackdrop.initialize()

const isHostedPage = document.body.classList.contains(HOSTED_APP_BODY_CLASS)
if (!isHostedPage) {
  OrderToast.initialize()
}

const app = new AppClient(onPageLoaded)

const pages: Array<ClientPage> = []
pages.push(new PageLogin())
pages.push(new PageVerifyEmails(app))
pages.push(new PageEditArticle())
pages.push(new PageEditLocation())
pages.push(new PageFeedback())
pages.push(new PageRestaurantDetails())
pages.push(new PanelSelectPlan())
pages.push(new PanelOpeningHours())
pages.push(new PanelMenuEditor())
pages.push(new PanelTeamInvite())
pages.push(new PanelDeliveryOptions())
pages.push(new PanelPublish())
pages.push(new PanelActivated())
pages.push(new PageOrders())
pages.push(new PagePrintOrder())
pages.push(new PagePrintMenu())
pages.push(new PagePrintQrMenu())
pages.push(new PageRestaurant())
pages.push(new PageStorePrinter())
pages.push(new PageRestaurantOrder())
pages.push(new PageRestaurantOrderConfirmation())
pages.push(new PageThemeEdit())
pages.push(new PageManageLeads())

app.start(pages)
;(window as any).CookiesEuBanner = CookiesEuBanner

new CookiesEuBanner(() => {
  // On cookies accepted
})
